<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<rect x="7.75" y="7.75" width="28.5" height="28.5" rx="14.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="14.666" cy="20.6445" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="20.5781" cy="27.5156" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="28.7715" cy="18.6445" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
